import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch, connect} from 'react-redux';
import {RootState} from '../../redux/reducers';
import Modal from '../Auth/Modal';

import {actionLoginError, actionLogout, actionProfile, toggleMenu, toggleModal, toggleModalType} from '../../redux/actions';
import {mediaQuery} from '../../helpers/utils';
import { Link, useLocation } from 'react-router-dom';
import { API_URL } from '../../constants';

const Avatar = (props:{username: string}) => {
    const {username} = props
    const imgUrl = username ? `${API_URL}/myprofile/?do=avatar&w=35&h=35` : `${API_URL}/img/user.svg`
    return <div className='hamburger' id='hamburger_div'>
        <img  id='hamburger_svg' src={imgUrl} />
    </div>
}

const Hamburger = (props:{username: string}) => {
    const {username} = props
    if (mediaQuery('(min-width: 1200px)')) {
        return <Avatar username={username}/>
    }

    return <div className='hamburger' id='hamburger_div'>
        <svg id='hamburger_svg' xmlns="http://www.w3.org/2000/svg"
             version="1.1" width="24" height="24" x="0" y="0"
             viewBox="0 0 384 384" className="">
            <g id="hamburger_path_top">
                <path id="hamburger_path" xmlns="http://www.w3.org/2000/svg" d="m368 154.667969h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" fill="#5a5a5a" data-original="#000000" className=""/>
                <path id="hamburger_path_t" xmlns="http://www.w3.org/2000/svg" d="m368 32h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" fill="#5a5a5a" data-original="#000000" className=""/>
                <path id="hamburger_path_three" xmlns="http://www.w3.org/2000/svg" d="m368 277.332031h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" fill="#5a5a5a" data-original="#000000" className=""/>
            </g>
        </svg>
    </div>
}

type MenuItem = {
    title: string;
    link: string|null;
    className: string|null;
    when: 'logged-in'|'logged-out'|null;
    callback?: string;
}

const composeItems = (username: string): MenuItem[] => {

    return [
        {title: 'Ürituste info lisamiseks', link: null, className: 'item-bold', when: 'logged-out'},
        {title: 'Registreeru', link: null, className: 'clickable', when: 'logged-out', callback:'showRegister'},
        {title: 'Logi sisse', link: null, className: 'clickable', when: 'logged-out', callback:'showLogin'},
        {title: username ? username : 'Minu konto', link: null, className: 'clickable', when: 'logged-in', callback:'showAccount'},
        {title: 'Minu üritused', link: null, className: 'clickable', when: 'logged-in', callback:'showEvents'},
        {title: 'Lisa üritus', link: null, className: 'clickable', when: 'logged-in', callback:'addEvent'},
        {title: 'Logi välja', link: null, className: 'clickable', when: 'logged-in', callback:'logout'},
        {title: '<hr />', link: '/abi', className: 'separator', when: null},
        {title: 'Abi', link: '/abi', className: 'clickable', when: null},
    ]
}

const MainMenu = (props: any) => {
    const { userProfile: {username}, isLoggedIn, loginError } = props;
    // @ts-ignore
    let opened = useSelector((state:RootState) => state.menuState)
    // @ts-ignore
    let showModalWindow = useSelector((state: RootState) => state.showModalWindow)
    // @ts-ignore
    let modalType = useSelector((state: RootState) => state.showModalType)
    
    let [loggedInState, setLoggedInState] = useState(false)
    let loggedIn = false;
    if (isLoggedIn && isLoggedIn.loggedIn) {
        loggedIn = true;
    }
    const dispatch = useDispatch()
    // const toggleMenu = () => {
    //     dispatch(toggleMenu())
    // }
    const showLogin = () => {

        dispatch(toggleModalType('login'));
        dispatch(toggleModal());
    }
    const showRegister = () => {

        dispatch(toggleModalType('register'));
        dispatch(toggleModal());
    }

    const showLoginError = () => {
        dispatch(toggleModalType('loginError'));
        dispatch(toggleModal());
        dispatch(actionLoginError(''));
    }

    const showAccount = () => {
        if (mediaQuery('(max-width: 992px)')) {
            dispatch(toggleModalType('precaution'));
            dispatch(toggleModal());
            return false
        }
        window.open(`${API_URL}/myprofile`, '_blank');
    }

    const showEvents = () => {
        if (mediaQuery('(max-width: 992px)')) {
            dispatch(toggleModalType('precaution'));
            dispatch(toggleModal());
            return false
        }
        window.open(`${API_URL}/extranet/?do=events`, '_blank');
    }

    const addEvent = () => {
        if (mediaQuery('(max-width: 992px)')) {
            dispatch(toggleModalType('precaution'));
            dispatch(toggleModal());
            return false
        }
        window.open(`${API_URL}/extranet`, '_blank');
    }

    const logout = () => {

        dispatch(actionLogout());
    }
    const onItemClick = (item: string) => {

        switch(item) {
            case 'showRegister':
                showRegister();
                break;
            case 'showLogin':
                showLogin();
                break;
            case 'showAccount':
                showAccount();
                break;
            case 'showEvents':
                showEvents();
                break;
            case 'addEvent':
                addEvent();
                break;
            case 'logout':
                logout();
                break;
            default:
                break;
        }
    }
    const location = useLocation()

    useEffect(() => {
        console.log({'loginError.message':loginError.message})
        if (loginError.message && loginError.message.startsWith('Vale') && !loggedIn) {
            showLoginError()
        }

        if (loggedIn !== loggedInState) {
            setLoggedInState(!loggedInState);
            //opened = true;

            if (location.search && location.search.indexOf('?show_menu') > -1 ) {
                dispatch(toggleMenu());
            } else {
                // @ts-ignore
                dispatch(toggleMenu(!loggedInState))
            }
            if (mediaQuery('(max-width: 992px)') && loggedIn) {
                dispatch(toggleModalType('precaution'));
                dispatch(toggleModal());
            }
        } else {
            if (location.search && location.search.indexOf('?show_menu') > -1 ) {
                dispatch(toggleMenu());
            }
        }
    }, [isLoggedIn])

    const DesktopItems = () => {
        if (mediaQuery('(min-width: 1200px)')) {
            return <div className="desktop-menu">
                <a href="http://blog.kultuurikava.ee/kontakt/" target="_blank">Kontakt</a>
                <a href="http://blog.kultuurikava.ee/abi/" target="_blank">Abi</a>
            </div>
        }
        return null
    }

    const menuItems = composeItems(username)
    return <div className='main-menu'>
            <DesktopItems />
            <Hamburger username={username}/>

            { opened && <div className='menu-list'>

                { menuItems.map((menuItem: MenuItem, idx: number) => {
                    if (menuItem.when === 'logged-in' && (loggedIn || username)) {
                        const className  = `menu-item ${menuItem.className}`;
                        return <div
                            key={idx}
                            className={className}
                            onClick={()=>onItemClick(menuItem.callback || 'none')}
                        >{ menuItem.title }</div>
                    }
                    if (menuItem.when === 'logged-out' && (!loggedIn && !username)) {
                        const className  = `menu-item ${menuItem.className}`;
                        return <div
                            key={idx}
                            className={className}
                            onClick={()=>onItemClick(menuItem.callback || 'none')}
                        >{ menuItem.title }</div>
                    }
                }) }
                { mediaQuery('(max-width: 1200px)') ?
                    <>
                        <div className='menu-item separator'>
                            <hr />
                        </div>
                        <div className='menu-item clickable'>
                            <Link to='/page/mis-on-kultuurikava/'>Abi</Link>
                        </div>
                        <div className='menu-item clickable'>
                            <a href='http://blog.kultuurikava.ee/kontakt/' target='_blank'>Kontakt</a>
                        </div>

                        <div className='menu-item clickable'>
                            <a href='https://www.kultuurikava.ee/page/privaatsustingimused' target='_blank'>Privaatsustingimused</a>
                        </div>
                        <div className='menu-item clickable'>
                            <a href='https://www.kultuurikava.ee/page/kasutustingimused' target='_blank'>Kasutustingimused</a>
                        </div>

                    </>:null }
            </div>}
            { showModalWindow ? <Modal dialog={modalType.type}/> : null }
    </div>
}


const mapStateToProps = (state: RootState) => {
    // @ts-ignore
    const {userProfile, isLoggedIn, showModalType, loginError} = state;
    return {userProfile, isLoggedIn, showModalType, loginError}
}
export default connect(mapStateToProps,{actionProfile})(MainMenu);
